import { GET_SEARCH_LIST,
GET_SEARCH_LIST_PROFILE } from "@/store/actions.type"
import { CLEAR_SEARCH_LIST } from "@/store/mutations.type"
export default {
    data: () => ({
        searchLoading: false
    }),

    created() {
        this.$store.commit(CLEAR_SEARCH_LIST)
    },

    computed: {
        items() {
            return this.$store.state.search.searchList
        }
    },

    methods: {
        getSearchList() {
            if (!this.searchLoading && !this.$store.state.search.searchListFetchCompleted) {
                this.searchLoading = true
                this.$store.dispatch(GET_SEARCH_LIST, {
                        key: this.$route.query.key
                    })
                    .then(() => {
                        this.searchLoading = false
                    })
            }
        },

        getSearchListProfile() {
            if (!this.searchLoading && !this.$store.state.search.searchListFetchCompleted) {
                this.searchLoading = true
                this.$store.dispatch(GET_SEARCH_LIST_PROFILE, {
                        key: this.$route.query.key
                    })
                    .then(() => {
                        this.searchLoading = false
                    })
            }
        }
    }
}